import { AsyncPipe } from '@angular/common';
import { Component, inject, input, output, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ChildOnboarding, ChildOnboardingStore, StatusPipe } from '@zero/onboarding/domain';
import { ButtonComponent, IconButtonComponent } from '@zero/shared/ui-web-design-system';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { filter, map } from 'rxjs';

@Component({
  selector: 'child-onboarding-onboardings-list',
  templateUrl: './onboardings-list.component.html',
  styleUrls: ['./onboardings-list.component.scss'],
  imports: [TranslocoPipe, IconButtonComponent, ButtonComponent, StatusPipe, AsyncPipe, IconButtonComponent],
})
export class OnboardingsListComponent {
  public readonly childOnboardings = input<ChildOnboarding[]>([]);
  public readonly underageOnboardingEnabled = input<boolean>(false);
  public readonly addOnboarding = output<void>();
  public readonly continueOnboarding = output<string>();
  public readonly confirmOnboarding = output<string>();
  public readonly deleteOnboarding = output<string>();

  public readonly checkDelete = signal<string>(null);

  public readonly store = inject(ChildOnboardingStore);
  readonly #customerStateFacade = inject(CustomerStateFacade);

  public readonly customerId$ = this.#customerStateFacade.customerBaseData$.pipe(
    filter((data) => !!data),
    map(({ customerId }) => customerId),
  );

  public continue(onboardingId: string): void {
    const selected = this.childOnboardings().find((onboarding) => onboarding.onboardingId === onboardingId);
    const underageOnboardingEnabled = this.underageOnboardingEnabled();
    if (selected && underageOnboardingEnabled) {
      this.continueOnboarding.emit(onboardingId);
    }
  }
}
